import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@inshared/shared/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { InvoicesSelectorService } from './invoices-selector.service';
import * as fromInvoices from './invoices.actions';
import { InvoicesService } from './invoices.service';

/** @deprecated moved to libs folder */
@Injectable()
export class InvoicesEffects {

    loadInvoices$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromInvoices.LOAD_INVOICES),
        map((action: fromInvoices.LoadInvoices) => action.payload),
        withLatestFrom(this.invoicesSelectorService.getInvoicesYearsLoaded$),
        mergeMap(([payload, years]) => {
            if (years.includes(payload.jaartal)) {
                return of(new fromInvoices.LoadingDone()) as Observable<Action>;
            }

            return this.invoicesService.getInvoices(payload.jaartal).pipe(
                map((totaal_factuur) => new fromInvoices.LoadInvoicesSuccess({ totaal_factuur })),
                catchError((errors) => of(new fromInvoices.SetError({ errors }))),
            );
        }),
    ));

    loadInvoiceDetail$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromInvoices.LOAD_INVOICE_DETAIL),
        map((action: fromInvoices.LoadInvoiceDetail) => action.payload),
        withLatestFrom(this.invoicesSelectorService.getInvoicesLoaded$),
        mergeMap(([payload, invoice_ids]) => {
            if (invoice_ids.includes(payload.factuur_id)) {
                return of(new fromInvoices.LoadingDone()) as Observable<Action>;
            }

            return this.invoicesService.getInvoiceDetail(payload.factuur_id).pipe(
                map((detail_factuur) => new fromInvoices.LoadInvoiceDetailSuccess({ detail_factuur })),
                catchError((errors) => of(new fromInvoices.SetError({ errors }))),
            );
        }),
    ));

    setPayment$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromInvoices.SET_PAYMENT),
        switchMap((action: fromInvoices.SetPayment) =>
            this.invoicesService.setPayment(action.payload.invoice_id, action.payload.bank_id).pipe(
                map((resultaat) => resultaat.data),
                map((resultaat) => new fromInvoices.SetPaymentSuccess({
                    url: resultaat.issuer_url,
                })),
                catchError((errors) => of(new fromInvoices.SetError({
                    errors: errors,
                })),
                ),
            )),
    ));

    setPaymentSuccuess$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromInvoices.SET_PAYMENT_SUCCESS),
        switchMap((action: fromInvoices.SetPaymentSuccess) => {
            this.window.location.href = action.payload.url;
            return EMPTY;
        }),
    ), { dispatch: false });

    constructor(
        private actions$: Actions,
        private invoicesService: InvoicesService,
        private invoicesSelectorService: InvoicesSelectorService,
        @Inject(WINDOW) private window: Window,
    ) { }
}
